import React from "react";

const Details = () => {
  return <h2>Details component</h2>;
};

export default Details;
